import { isAuth0Authenticated } from '@futrli/shared-services';

import { AuthStoreState } from '../core/types';
import { CUSTOM_ATTRIBUTES } from './constants';

/**
 * Checks if an user is authed.
 * @function checkIfAuthed
 * @param {Object} authReducers
 * @returns {Boolean}
 */
export const checkIfAuthenticated = (authReducers: AuthStoreState) => {
  return Boolean(authReducers.authenticatedUser) || isAuth0Authenticated();
};

/**
 * Gets the custom domain where the user registered in order to redirect in the confirmation email.
 * @return {object} custom signUp domain
 */
export const getCustomDomain = () => ({
  [CUSTOM_ATTRIBUTES.SIGNUP_DOMAIN]: `${location.protocol}//${location.host}`
});

export const getCustomBusinessPhoneNumber = (phoneNumber: string) => ({
  [CUSTOM_ATTRIBUTES.BUSINESS_PHONE_NUMBER]: phoneNumber
});

export const getCustomBusinessType = (businessType: string) => ({
  [CUSTOM_ATTRIBUTES.BUSINESS_TYPE]: businessType
});
